import { createSelector } from 'reselect';
import { RootState } from './store';

// Base selector for navigationdata slice
const selectNavigationData = (state: RootState) => state.navigationdata;

// Memoized selector for modal data
export const selectModalData = createSelector([selectNavigationData], (navigationdata) => navigationdata.modalData);
